import { useNotification as useNotificationUtil } from '@amzn/event-engine-js-utils';
import { state as notificationsState } from 'atoms/notifications';
import { useCallback, useEffect } from 'react';
import { useSetRecoilState } from 'recoil';

interface UseNotificationOptions {
    clearNotificationsOnUnmount?: boolean;
}

interface UseNotificationValue extends ReturnType<typeof useNotificationUtil> {
    clearAllNotifications: () => void;
}

const useNotification = ({
    clearNotificationsOnUnmount,
}: UseNotificationOptions = {}): UseNotificationValue => {
    const setNotifications = useSetRecoilState(notificationsState);
    const useNotificationOutput = useNotificationUtil({
        setNotifications,
    });
    const clearAllNotifications = useCallback(() => {
        setNotifications([]);
    }, []);

    useEffect(() => {
        return () => {
            if (clearNotificationsOnUnmount) {
                useNotificationOutput.clearNotification();
            }
        };
    }, [clearNotificationsOnUnmount]);

    return {
        ...useNotificationOutput,
        clearAllNotifications,
    };
};

export default useNotification;
